export const ListUsersFilters = {
	disables: 0,
	actives: 1,
	waits: 2,
	deletes: 3
}

export class ListUsers {
	public currentPage = 0;
	public itemsByPage = 10;
	public order = {};
	public currentFilter = ListUsersFilters.actives;

	constructor () {
		// por defecto muestra listado de usuarios activos.
		this.currentFilter = ListUsersFilters.actives;
		// Actual página.
		this.currentPage = 0;
		// Cantidad de registros por página.
		this.itemsByPage = 10;
		// Orden de prioridad de las columnas y orden alfabético.
		// (1 = A...Z) y (-1 = Z...A)
		// La primera columna es al que tiene prioridad, en este caso 'nombre'.
		this.order = {
			nombre: 1,
			apellidos: 1,
			email: 1,
			empresa: 1,
			numCliRivisa: 1,
		};
	}
}
